import { render, staticRenderFns } from "./CurrencyHud.vue?vue&type=template&id=02473602&"
import script from "./CurrencyHud.vue?vue&type=script&lang=js&"
export * from "./CurrencyHud.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyHud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports